import { Suspense, type ComponentType, type ReactNode } from "react";

export function withSuspenseBoundary<P extends {}>(
  WrappedComponent: ComponentType<P>,
  fallback: ReactNode,
): React.FC<P> {
  const ComponentWithBoundary: React.FC<P> = (props) => {
    return (
      <Suspense fallback={fallback}>
        <WrappedComponent {...(props as P)} />
      </Suspense>
    );
  };

  ComponentWithBoundary.displayName = `withSuspenseBoundary(${
    WrappedComponent.displayName || WrappedComponent.name || "Component"
  })`;

  return ComponentWithBoundary;
}
